import React, { Component } from 'react';
import AppContainer from './components/application';
import {LANGUAGE, LITHUANIAN_LANGUAGE, COUNTRY_OPTIONS, UNDEFINED} from './constants/AppConstants';
import Heading from './components/heading';
import ContentContainer from './components/content/';
import moment from 'moment';
import FormContainer from './containers/FormContainer';
import { goToAnchor } from 'react-scrollable-anchor'


function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
      }
  }
  return "";
}

var expiration = moment("2018-09-19T21:00+0000");

class App extends Component {
  state = {
    activeIndex: 0,
    isChecked: false,
    clockVisible: false,
    formVisible: false,
    expiration: expiration,
    days: expiration.diff(moment(), 'days'),
    hours: expiration.diff(moment(), 'hours') % 24 ,
    minutes: expiration.diff(moment(), 'minutes') % 60 ,
    seconds: expiration.diff(moment(), 'seconds') % 60 ,
    selectedLanguage: LITHUANIAN_LANGUAGE,
    languageValue: COUNTRY_OPTIONS.find(x => x.value === LITHUANIAN_LANGUAGE).key,
    lang: LANGUAGE[COUNTRY_OPTIONS.find(x => x.value === LITHUANIAN_LANGUAGE).key],
    selectedChallenge: "T1",
  }

  interval = null;

  componentDidMount() {
    var lang = getCookie("language");
    lang = lang === "en"? "gb" : "lt";
    if (lang === "gb") {
      document.title = "Novameta talent 2018";
    } else if (lang === "lt") {
      document.title = "Novameta talentas 2018"
    }
    const {expiration} = this.state;
    if (typeof lang !== UNDEFINED) 
    {
      if (COUNTRY_OPTIONS.findIndex(x => x.key === lang) !== -1)
      {
        this.setState({
          activeIndex: expiration.diff(moment(), 'milliseconds') < 0? 1 : 0,
          selectedLanguage: COUNTRY_OPTIONS.find(x => x.key === lang).value,
          languageValue: lang,
          lang: LANGUAGE[lang]
        })
      }     
    }
    this.interval = setInterval(() => {
      var {activeIndex} = this.state;
      this.setState({
        days: expiration.diff(moment(), 'days'),
        hours: expiration.diff(moment(), 'hours') % 24 ,
        minutes: expiration.diff(moment(), 'minutes') % 60 ,
        seconds: expiration.diff(moment(), 'seconds') % 60 ,

      })
      

      if (activeIndex === 0 && expiration.diff(moment(), 'milliseconds') < 0) {
        this.setState({formVisible: false});
        setTimeout(() => {
          this.setState({
            activeIndex: 1,
            formVisible: true,
          });
        }, 500)
      }
    }, 500)

    setTimeout(() => {
      this.setState(
        {
          formVisible: true
        })
    }, 1750);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleChange = (e, {name, value}) => {
    this.setState({
      [name]: value,
      languageValue: COUNTRY_OPTIONS.find(x => x.value === value).key,
      lang: LANGUAGE[COUNTRY_OPTIONS.find(x => x.value === value).key],
    });

    if (COUNTRY_OPTIONS.find(x => x.value === value).key === "gb") {
      document.title = "Novameta talent 2018";
    } else if (COUNTRY_OPTIONS.find(x => x.value === value).key === "lt") {
      document.title = "Novameta talentas 2018"
    }
  }

  handleCheck = () => {
    var {isChecked} = this.state;
    this.setState({isChecked: !isChecked});
  }

  handleChallengeClick = (e, name, to) => {
    this.setState({selectedChallenge: name});
    goToAnchor("details", false);
  }

  handleButtonClick = (e, {type}) => {
    var {activeIndex} = this.state;
    if (activeIndex === 1) {
      this.setState({formVisible: false});
      setTimeout(() => {
        this.setState({activeIndex: 2, isChecked: false, formVisible: true});
        goToAnchor("home", false);
      }, 500)
    }
    if (activeIndex === 2) {
      this.setState({formVisible: false});
      setTimeout(() => {
        this.setState({activeIndex: 1, isChecked: false, formVisible: true});
        goToAnchor("home", false);
      }, 500)
    }
  }


  render() {
    var {activeIndex, isChecked, formVisible, lang, selectedLanguage, languageValue, days, hours, minutes, seconds, selectedChallenge} = this.state;

    return (
      <AppContainer>
          <ContentContainer lang={lang} selectedLanguage={selectedLanguage}>
            <Heading lang={lang} selectedLanguage={selectedLanguage} languageValue={languageValue} languageOptions={COUNTRY_OPTIONS} handleChange={this.handleChange} />
            <FormContainer activeIndex={activeIndex} isChecked={isChecked} handleCheck={this.handleCheck} visible={formVisible} days={days} hours={hours} minutes={minutes} seconds={seconds} handleButtonClick={this.handleButtonClick} lang={lang} selectedLanguage={selectedLanguage} selectedChallenge={selectedChallenge} handleChallengeClick={this.handleChallengeClick} />
          </ContentContainer>
      </AppContainer>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js